/* StarWays 2.0 — compacte footer, lichtgrijs */
import React from "react";
import { Link } from "react-router-dom";
import { StarWaysLogo } from "./Brand";

const linkStyle = {
  color: "var(--sw-ink-soft)",
  fontSize: 13,
  textDecoration: "none",
};

export const SwFooter = () => (
  <footer
    data-testid="sw-footer"
    style={{
      borderTop: "1px solid var(--sw-line)",
      background: "var(--sw-mist)",
      padding: "32px 0 48px",
      marginTop: 64,
    }}
  >
    <div className="sw-container">
      <div style={{ display: "flex", flexWrap: "wrap", gap: 24, justifyContent: "space-between", alignItems: "flex-start" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Link to="/" aria-label="StarWays home" data-testid="sw-footer-logo" style={{ display: "inline-flex" }}>
            <StarWaysLogo size={18} />
          </Link>
          <span style={{ color: "var(--sw-ink-soft)", fontSize: 13 }}>
            KvK 95204458 · BTW NL005138645B25
          </span>
          <a href="mailto:info@starways.nl" style={linkStyle}>info@starways.nl</a>
          <a href="tel:+31631513541" style={linkStyle}>+31 6 31 51 35 41</a>
        </div>

        <nav aria-label="Pagina's" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Link to="/tarieven" style={linkStyle}>Tarieven</Link>
          <Link to="/veelgestelde-vragen" style={linkStyle}>Veelgestelde vragen</Link>
          <Link to="/voor-chauffeurs" style={linkStyle}>Rijden voor StarWays</Link>
          <Link to="/voor-bedrijven" style={linkStyle}>Voor bedrijven</Link>
          <Link to="/voor-hotels" style={linkStyle}>Voor hotels</Link>
        </nav>

        <nav aria-label="Routes" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Link to="/schiphol-taxi-almere" style={linkStyle}>Schiphol-taxi Almere</Link>
          <Link to="/schiphol-taxi-gooi" style={linkStyle}>Schiphol-taxi 't Gooi</Link>
          <Link to="/premium-taxi-amsterdam" style={linkStyle}>Premium taxi Amsterdam</Link>
        </nav>

        <nav aria-label="Juridisch" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Link to="/algemene-voorwaarden" style={linkStyle}>Voorwaarden</Link>
          <Link to="/privacybeleid" style={linkStyle}>Privacy</Link>
          <Link to="/cookiebeleid" style={linkStyle}>Cookies</Link>
        </nav>
      </div>

      <div style={{ marginTop: 32, paddingTop: 16, borderTop: "1px solid var(--sw-line)", color: "var(--sw-ink-soft)", fontSize: 12 }}>
        © {new Date().getFullYear()} StarWays
      </div>
    </div>
  </footer>
);

export default SwFooter;
